import { t } from "@/i18n-js/instance";
import { ProgressiveImage } from "@circle-react/components/shared/ProgressiveImage";
import { useAIAgentsLocalizedFeatureImages } from "@circle-react/config/Locales/AIAgentsLocalizedFeatureImages";
import { Blocks } from "../Blocks";
import { localeRoot as communityBotLocale } from "../constants";

const localeRoot = `${communityBotLocale}.blocks.chat_agents_feature`;

const backgroundColors = {
  primary: "#CFD8FE",
  secondary: "#F4F6FF",
};

interface ChatAgentsFeatureProps {
  featureNumber: number;
}

export const ChatAgentsFeature = ({
  featureNumber,
}: ChatAgentsFeatureProps) => {
  const imageVariants = useAIAgentsLocalizedFeatureImages(featureNumber);

  return (
    <Blocks>
      <Blocks.FeatureSummary backgroundColor={backgroundColors.secondary}>
        <Blocks.Header
          localeRoot={localeRoot}
          iconName="20-ai-agents"
          backgroundColor={backgroundColors.primary}
        />
        <Blocks.FeatureList>
          <Blocks.FeatureItem backgroundColor={backgroundColors.primary}>
            {t([localeRoot, "features", "0"])}
          </Blocks.FeatureItem>
          <Blocks.FeatureItem backgroundColor={backgroundColors.primary}>
            {t([localeRoot, "features", "1"])}
          </Blocks.FeatureItem>
          <Blocks.FeatureItem backgroundColor={backgroundColors.primary}>
            {t([localeRoot, "features", "2"])}
          </Blocks.FeatureItem>
        </Blocks.FeatureList>
      </Blocks.FeatureSummary>
      <Blocks.FeaturePreview
        backgroundColor={backgroundColors.primary}
        className="flex flex-col items-center justify-center"
      >
        {imageVariants && (
          <ProgressiveImage
            src={imageVariants.large}
            srcVariants={imageVariants}
            alt={t([localeRoot, "image_alt"])}
            className="w-[300px] md:w-auto"
          />
        )}
      </Blocks.FeaturePreview>
    </Blocks>
  );
};
